import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Configuration flag - set to false to use mock database
export const USE_REAL_FIREBASE = true;

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyClMt5ynfYISwDSFTwD46ss2ogNeR-hCwU",
  authDomain: "cursonapptest.firebaseapp.com",
  projectId: "cursonapptest",
  storageBucket: "cursonapptest.firebasestorage.app",
  messagingSenderId: "108335330872",
  appId: "1:108335330872:web:7c34b969a0b1e1302ed8cd",
  measurementId: "G-NPVV09Z00N",
};

// Always initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);

if (USE_REAL_FIREBASE) {
  console.log("Using real Firebase Firestore and Auth");
} else {
  console.log("Using mock database for development");
}

// Export Firestore Database and Auth
export { db, auth };

// Export the app
export default app;
